import { TransactionStatusEnum } from '../../../../tenant/transactions/enums/transaction-status.enum';

/**
 * Transaction statuses left off a rental account statement.
 * Completed and refunded rows are the ones that count as paid.
 */
export const EXCLUDED_TRANSACTION_STATUSES: TransactionStatusEnum[] = [
  TransactionStatusEnum.PENDING,
  TransactionStatusEnum.PROCESSING,
  TransactionStatusEnum.RETRYING,
  TransactionStatusEnum.FAILED,
  TransactionStatusEnum.CANCELLED,
  TransactionStatusEnum.EXPIRED,
];
